import(/* webpackMode: "eager" */ "/app/src/app/industries/food-and-beverage/page.tsx");
